var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exam-guide"},[_c('SiteHeader'),_vm._v(" "),_c('SiteMenu'),_vm._v(" "),(_vm.$route.meta.hideExamGuideView)?_c('ExamGuideView'):_vm._e(),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('SiteFooter')],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }